export function FormTextarea({
  label,
  value,
  onChange,
  placeholder = "",
  rows = 2,
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-900 mb-2">
        {label}
      </label>
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 text-sm resize-none"
      />
    </div>
  );
}
